module.exports = __webpack_public_path__ + "img/education.9ba848da.svg";